export const VIDEO_TIMESTAMP_PARAM = 'vts';
export const SHORTS_MOCK_TEST_THUMBNAIL = 'https://885765335.fs1.hubspotusercontentqa-na1.net/hubfs/885765335/rectangle-default-thumbnail-image-Nov-26-2025-02-31-21-1660-PM.png';